import { Button, Paper } from '@mui/material';

import { useTrans } from "~/hooks/useTrans";
import Loader from '~/components/Loader';
import { userStore } from "~/stores/user";
import MainTitle from "~/components/MainTitle";
import ExternalButtonLink from "~/components/ExternalButtonLink";
import { useLang } from "~/hooks/useLang";
import { getHowToRegisterLink, getRegisterLink } from "~/utils/utils";
import WhatAbout from "~/components/WhatAbout";
import ErrorInfo from "~/components/ErrorInfo";

import "./style.less";

export default function Unauthorized() {
	const { lang } = useLang();
	const { trans } = useTrans();
	const { userLoad } = userStore(userState => ({
		userLoad: userState.userLoad,
	}));

	function onLoginClick() {
		window.login?.open();
	}

	return <div className="unauthorized">
		<MainTitle title={trans("unauthorizedPage.logged.false")} />
		<div className="unauthorized__content">
			<Paper elevation={3} className="unauthorized__paper">
				{ userLoad.meLoaded && <>
					<p>
						{ trans("unauthorizedPage.infoLine1") }
					</p>
					<div className="unauthorizedPage__buttons">
						<Button color="success" variant="contained" onClick={onLoginClick}>
							{ trans("unauthorizedPage.login") }
						</Button>
						<ExternalButtonLink label={trans("unauthorizedPage.register")} link={getRegisterLink(lang)} color="secondary" />
						<WhatAbout title={trans("unauthorizedPage.howToLoginRegister")} link={getHowToRegisterLink(lang)} />
					</div>
					{ userLoad.errorMsg && <ErrorInfo msg={userLoad.errorMsg} className="margin-top-large" /> }
				</> }
				{ !userLoad.meLoaded && <>
					<Loader msg={trans("loadingMe.title")} />
				</> }
			</Paper>
		</div>
	</div>;
}
